module.exports = __webpack_public_path__ + "static/media/file-user.ee741a6c.svg";